// src/components/Header.js
import React from 'react';
import houvalLogo from '../../images/HouvalLight.png'; // Adjust the path if necessary
import PropTypes from 'prop-types'; // Optional: For prop type checking

const Header = ({ propertyDetails, pageNumber }) => {
  return (
    <header className="w-full h-16 bg-gray-600 flex items-center px-4 relative">
      {/* Logo on the Left */}
      <div className="flex-shrink-0">
        <img
          src={houvalLogo}
          alt="Houval Company Logo"
          className="h-12 w-auto"
        />
      </div>

      {/* Property Address in the Center */}
      <div className="absolute left-1/2 transform -translate-x-1/2">
        <p className="text-white text-sm">
          {/*{propertyDetails.propertyAddress || 'Property Address Not Available'}*/}
        </p>
      </div>

      {/* Page Number on the Right */}
      <div className="flex-shrink-0 ml-auto">
        <p className="text-white">Page {String(pageNumber)}</p>
      </div>
    </header>
  );
};

// Optional: Adding PropTypes for type checking
Header.propTypes = {
  propertyDetails: PropTypes.shape({
    propertyAddress: PropTypes.string.isRequired,
    // Add other propertyDetails fields if necessary
  }).isRequired,
  pageNumber: PropTypes.number.isRequired,
};

export default Header;
